<template>
  <span v-resize="checkMobile" :style="isMobile ? 'padding: 5px !important;' : ''">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card>
      <v-card-text ref="chatContainer" style="scroll-margin-bottom: 150px;">
        <v-row class="no-gutters elevation-4">
          <v-col cols="12" sm="3" class="flex-grow-1 flex-shrink-0" style="border-right: 1px solid #0000001f;">
            <v-responsive class="overflow-y-auto fill-height" height="800">
              <v-list subheader>
                <v-list-item-group>
                  <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('custom.search')"
                    class="mx-3 my-3" single-line clearable hide-details></v-text-field>
                </v-list-item-group>
                <v-list-item-group v-model="activeChat">
                  <template v-for="(item, index) in parents">
                    <v-list-item :key="`parent-${item.id}-${index}`" :value="item.id" @click="loadMessages(item)">
                      <v-list-item-avatar color="grey lighten-1 white--text">
                        <v-avatar :color="item.bookings ? 'success' : 'grey lighten-1'" size="40" class="m-2">
                          <v-flex class="text-uppercase">
                            {{ item.name ? item.name[0] : '' }} {{ item.lastname ? item.lastname[0] : '' }}
                          </v-flex>
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-badge v-if="item.have_unreaded_message" color="deep-purple accent-4" dot>
                            <span v-text="item.name + ' ' + item.lastname"></span>
                          </v-badge>
                          <span v-else v-text="item.name + ' ' + item.lastname"></span>
                        </v-list-item-title>
                        <v-list-item-subtitle v-text="formatPhone(item.phone)" />
                        <v-list-item-subtitle>
                          {{ returnBookingsInfo(item) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="`divider-${item.id}-${index}`" class="my-0" />
                  </template>
                </v-list-item-group>
              </v-list>
            </v-responsive>
          </v-col>

          <v-col v-if="messages && messages.length > 0">
            <v-card v-for="(message, index) in messages" :key="index" flat>
              <v-list-item :key="`incoming-${message.timestamp}`" v-if="message.type != 'outgoing'" class="">
                <v-list-item-avatar class="align-self-start mr-2">
                  <v-avatar size="40" color="success" @click="replaceToClientCard()" v-tooltip="{
                    content: `${client.lastname} ${client.name} ${client.middlename} ${formatPhone(client.phone)}`,
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                    {{ client.name ? client.name[0] : '' }} {{ client.lastname ? client.lastname[0] : '' }}
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content class="received-message">
                  <v-card v-if="message.typeMessage == 'textMessage'" color="success" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column">
                      <span class="text-caption"></span>
                      <span class="align-self-start text-subtitle-1">{{ message.textMessage }}</span>
                      <span class="text-caption font-italic align-self-end">
                        <timeago :datetime="formatTime(message.timestamp)" :auto-update="60" :locale="$i18n.locale">
                        </timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                  <v-card v-if="message.typeMessage == 'imageMessage'" color="success" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column">
                      <span class="text-caption">{{ message.textMessage }}</span>
                      <media-thumb :lazy-src="'data:image/png;base64,' + message.jpegThumbnail" max-height="150"
                        max-width="250" :src="message.downloadUrl"
                        @click="saveFile(message.downloadUrl, message.fileName)"
                        :name="message.fileName"
                        :aspect-ratio="null" />
                      <span class="text-caption font-italic align-self-end">
                        <timeago :datetime="formatTime(message.timestamp)" :auto-update="60" :locale="$i18n.locale">
                        </timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                  <v-card v-if="message.typeMessage == 'audioMessage'" color="success" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column">
                      <span class="text-caption">{{ message.textMessage }}</span>
                      <span class="align-self-start text-subtitle-1">
                        <audio controls>
                          <source :src="message.downloadUrl" type="audio/ogg">
                          <source :src="message.downloadUrl" type="audio/mpeg">
                          Your browser does not support the audio element.
                        </audio>
                      </span>
                      <span class="text-caption font-italic align-self-end">
                        <timeago :datetime="formatTime(message.timestamp)" :auto-update="60" :locale="$i18n.locale">
                        </timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                  <v-card v-if="message.typeMessage == 'documentMessage'" color="success" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column">
                      <span class="text-caption">{{ message.textMessage }}</span>
                      <v-btn color="primary" text @click="saveFile(message.downloadUrl, message.fileName)">
                        {{ message.fileName }}
                      </v-btn>
                      <span class="text-caption font-italic align-self-end">
                        <timeago :datetime="formatTime(message.timestamp)" :auto-update="60" :locale="$i18n.locale">
                        </timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                  <v-card v-if="message.typeMessage == 'videoMessage'" color="success" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column" style="cursor: pointer;">
                      <span class="text-caption">{{ message.textMessage }}</span>
                      <media-thumb :lazy-src="'data:image/png;base64,' + message.jpegThumbnail" max-height="150"
                        max-width="250" :src="message.downloadUrl"
                        @click="saveFile(message.downloadUrl, message.fileName)"
                        :name="message.fileName"
                        :aspect-ratio="null" />
                      <span class="text-caption font-italic align-self-end">
                        <timeago :datetime="formatTime(message.timestamp)" :auto-update="60" :locale="$i18n.locale">
                        </timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                  <v-card v-if="message.typeMessage == 'extendedTextMessage'" color="success" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column">
                      <span class="text-caption"></span>
                      <span class="align-self-start text-subtitle-1">{{ message.textMessage }}</span>
                      <!-- <span class="align-self-start text-subtitle-1">{{ message.extendedTextMessage }}</span> -->
                      <span class="text-caption font-italic align-self-end">
                        <timeago :datetime="formatTime(message.timestamp)" :auto-update="60" :locale="$i18n.locale">
                        </timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-else :key="`outgoing-${message.timestamp}`">
                <v-list-item-content class="sent-message justify-end">
                  <v-card v-if="message.typeMessage == 'textMessage'" color="primary" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column">
                      <span class="text-caption"></span>
                      <span class="align-self-start text-subtitle-1">{{ message.textMessage }}</span>
                      <span class="text-caption font-italic align-self-end">
                        <timeago :datetime="formatTime(message.timestamp)" :auto-update="60" :locale="$i18n.locale">
                        </timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                  <v-card v-if="message.typeMessage == 'extendedTextMessage'" color="primary" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column">
                      <span class="text-caption"></span>
                      <span class="align-self-start text-subtitle-1">{{ message.textMessage }}</span>
                      <!-- <span class="align-self-start text-subtitle-1">{{ message.extendedTextMessage }}</span> -->
                      <span class="text-caption font-italic align-self-end">
                        <timeago :datetime="formatTime(message.timestamp)" :auto-update="60" :locale="$i18n.locale">
                        </timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                  <v-card v-if="message.typeMessage == 'imageMessage'" color="primary" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column">
                      <span class="text-caption">{{ message.textMessage }}</span>
                      <media-thumb :lazy-src="'data:image/png;base64,' + message.jpegThumbnail" max-height="150"
                        max-width="250" :src="message.downloadUrl"
                        @click="saveFile(message.downloadUrl, message.fileName)"
                        :name="message.fileName"
                        :aspect-ratio="null" />
                      <span class="text-caption font-italic align-self-end">
                        <timeago :datetime="formatTime(message.timestamp)" :auto-update="60" :locale="$i18n.locale">
                        </timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                  <v-card v-if="message.typeMessage == 'audioMessage'" color="primary" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column">
                      <span class="text-caption">{{ message.textMessage }}</span>
                      <span class="align-self-start text-subtitle-1">
                        <audio controls>
                          <source :src="message.downloadUrl" type="audio/ogg">
                          <source :src="message.downloadUrl" type="audio/mpeg">
                          Your browser does not support the audio element.
                        </audio>
                      </span>
                      <span class="text-caption font-italic align-self-end">
                        <timeago :datetime="formatTime(message.timestamp)" :auto-update="60" :locale="$i18n.locale">
                        </timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                  <v-card v-if="message.typeMessage == 'documentMessage'" color="primary" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column">
                      <span class="text-caption">{{ message.textMessage }}</span>
                      <v-btn color="secondary" text @click="saveFile(message.downloadUrl, message.fileName)">
                        {{ message.fileName ? message.fileName : 'Download' }}
                      </v-btn>
                      <span class="text-caption font-italic align-self-end">
                        <timeago :datetime="formatTime(message.timestamp)" :auto-update="60" :locale="$i18n.locale">
                        </timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                  <v-card v-if="message.typeMessage == 'videoMessage'" color="primary" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column" style="cursor: pointer;">
                      <span class="text-caption">{{ message.textMessage }}</span>
                      <media-thumb :lazy-src="'data:image/png;base64,' + message.jpegThumbnail" max-height="150"
                        max-width="250" :src="message.downloadUrl"
                        @click="saveFile(message.downloadUrl, message.fileName)"
                        :name="message.fileName"
                        :aspect-ratio="null" />
                      <span class="text-caption font-italic align-self-end">
                        <timeago :datetime="formatTime(message.timestamp)" :auto-update="60" :locale="$i18n.locale">
                        </timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                </v-list-item-content>
                <v-list-item-avatar class="align-self-start ml-2" @click="replaceToClientCard()">
                  <v-avatar size="40" color="primary">
                    {{ $t('custom.you') }}
                  </v-avatar>
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
            <v-container class="ma-0 px-3" v-if="!isLoading && messages && messages.length > 0">
              <v-row no-gutters>
                <v-col>
                  <v-flex class="d-flex align-center">
                    <v-file-input class="flex-none" hide-input hide-details flat truncate-length="15"
                      v-model="sended_file" dense inline solo></v-file-input>
                    <v-textarea rows="1" autofocus auto-grow v-model="sended_message" class="w-full"
                      :placeholder="$t('companies.type_something')" @keypress.enter="sendMesssage()"></v-textarea>
                    <v-btn icon class="ml-4" @click="sendMesssage()"><v-icon>mdi-send</v-icon></v-btn>
                  </v-flex>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col v-else>
            <v-card flat class="w-full">
              <v-list-item class="w-full">
                <v-list-item-content class="w-full">
                  <v-card class="w-full p-5">
                    <v-card-text class="white--text pa-2 w-full text-center">
                      <h3>{{ $t('whatsapp.select_client') }}</h3>
                    </v-card-text>
                  </v-card>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </span>
</template>
<script>
import MediaThumb from "@/components/MediaThumb.vue";
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
// moment.locale("ru");
import { saveAs } from "file-saver";
import CableSubscriber from "@/mixins/CableSubscriber";
import { whatsappChatErrorKey, whatsappChatReady, WHATSAPP_CHAT_MAX_FILE_BYTES } from "@/utils/greenApiProvider"; // FT-195
import { formatPhone } from "@/lib/phone/display";

export default {
  components: { MediaThumb },
  mixins: [CableSubscriber],
  data() {
    return {
      subscribedCompanyId: null, // ID компании для отписки от канала
      client: null,
      activeChat: null,
      parents: [],
      bookings: [],
      messages: [],
      sended_message: null,
      sended_file: null,
      search: null,
      isMobile: false,
      isLoading: false,
    };
  },
  mounted() {
    let self = this;
    if (this.$store.getters.isLoggedIn &&
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.id) {
      this.whatsappSub = this.$cableSubscribe(
        { channel: "WhatsappChannel", room: this.$store.getters.getCompany.company.id },
        {
          connected: () => this.onWhatsappConnected(),
          received: (data) => this.onWhatsappReceived(data),
        },
      );
    }
  },
  updated() {
    // Только тут работает
    // this.scrollToBottom();
    // выключаем crisp
    if (typeof $crisp !== "undefined" && $crisp) {
      $crisp.push(["do", "chat:hide"]);
    }
  },
  created() {
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      // выключаем crisp
      if (typeof $crisp !== "undefined" && $crisp) {
        $crisp.push(["do", "chat:hide"]);
      }
      // get search from state
      this.search = this.$store.getters.getWhatsappSearchClient;
      this.getClients();
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  // FT-066: WhatsappChannel sub auto-unsubscribed by CableSubscriber mixin (no manual beforeDestroy).
  watch: {
    search() {
      this.$store.commit("setWhatsappSearchClient", this.search);
      if (this.search == "") {
        this.search = null;
      } else {
        // set search to state
        let self = this;
        this.page = 1;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.getClients();
          }, 300); // delay
        }
        debounce();
      }
    },
  },
  computed: {
    chatReady() {
      return whatsappChatReady(this.company);
    },
    clients_sources() {
      if (this.$store.getters.getCompany.company.clients_sources) {
        return this.$store.getters.getCompany.company.clients_sources;
      } else {
        return [];
      }
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    company() {
      if (this.$store.getters.getCompany) {
        return this.$store.getters.getCompany.company;
      } else {
        return null;
      }
    },
  },
  methods: {
    formatPhone,
    onWhatsappConnected() {
      console.log("Connected to WhatsappChannel");
    },
    // Moved 1:1 from the old WhatsappChannel received handler (arrow → `this` is the component).
    onWhatsappReceived(data) {
      if (data) {
        if (data.client && data.client.id) {
          if (this.parents.find((item) => item.id == data.client.id)) {
            let client = this.parents.find((item) => item.id == data.client.id);
            // заменяем данные клиента в родителях
            client.have_unreaded_message = true;
            this.parents.splice(this.parents.findIndex((item) => item.id == data.client.id), 1, client);

            if (this.activeChat && this.activeChat == data.client.id) {
              this.messages.push(data);
              console.log(data)
            }
          } else {
            this.parents.unshift(data.client);
          }
        }
      }
    },
    // FT-195 REQ-06: история и отправка — через сервер (токен инстанса Green API браузеру не отдаётся).
    // Сервер сам берёт инстанс компании и строит chatId из телефона клиента.
    loadMessages(client) {
      if (!this.chatReady) {
        this.$notify(this.$t("errors.error"), this.$t("errors.error"), "error", 5000);
        return;
      }
      this.client = client;
      this.activeChat = client.id;
      // заменяем данные клиента в родителях
      const index = this.parents.findIndex((item) => item.id == client.id);
      if (index !== -1) {
        const parent = this.parents[index];
        parent.have_unreaded_message = false;
        this.parents.splice(index, 1, parent);
      }
      this.isLoading = true;
      this.axios
        .get(`/api/v1/whatsapp_chat/clients/${client.id}/history`, {
          params: { count: 50 },
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then((response) => {
          this.messages = (response.data || []).slice().reverse();
        })
        .catch((error) => {
          this.notifyChatError(error);
        })
        .finally(() => (this.isLoading = false));
    },
    getClients() {
      this.isLoading = true;
      let self = this;
      this.axios
        .post(
          `/api/v1/index_clients_whatsapp`,
          {
            search: this.search,
            page: 1,
            per_page: 20,
            sort_by: "id",
            direction: "desc",
            debtor: false,
            entity: false,
            meilisearch: true,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.parents = response.data.clients;
          this.bookings = response.data.bookings;

          // ищем брони клиента и добавляем в него
          this.parents.forEach((parent) => {
            self.bookings.forEach((booking) => {
              if (booking.client_id == parent.id) {
                if (parent.bookings) {
                  parent.bookings.push(booking);
                } else {
                  parent.bookings = [booking];
                }
              }
            });
          });
        })
        .catch((error) => {
          console.log(error);
          this.setError(error, this.$t("errors.clients_load"));
        })
        .finally(() => (this.isLoading = false));
    },
    lastMessage(messages) {
      if (messages && messages.length > 0) {
        return messages[messages.length - 1].textMessage;
      } else {
        return null;
      }
    },
    returnBookingsInfo(client) {
      let bookings = client.bookings;
      if (bookings && bookings.length > 0) {
        let result = "";
        bookings.forEach((booking) => {
          result += `${booking.car_code} ${booking.start_date} ${booking.end_date} \n`;
        });
        return result;
      } else {
        return null;
      }
    },
    sendMesssage() {
      const hasText = !!(this.sended_message && this.sended_message.trim().length > 0);
      if (!hasText && !this.sended_file) {
        this.$notify(this.$t("errors.error"), this.$t("errors.error"), "error", 5000);
        return;
      }
      if (this.sended_file) {
        this.sendFile();
        return;
      }
      this.isLoading = true;
      this.axios
        .post(
          `/api/v1/whatsapp_chat/clients/${this.client.id}/messages`,
          { message: this.sended_message },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        )
        .then(() => {
          this.scrollToBottom();
          this.messages.push({
            "type": 'outgoing',
            "typeMessage": "textMessage",
            "textMessage": this.sended_message,
            "timestamp": Math.floor(Date.now() / 1000)
          });
          this.sended_message = "";
        })
        .catch((error) => {
          this.notifyChatError(error);
        })
        .finally(() => (this.isLoading = false));
    },
    sendFile() {
      const file = this.sended_file;
      if (file.size > WHATSAPP_CHAT_MAX_FILE_BYTES) {
        this.$notify(this.$t("crm.messages.file_too_big"), "", "warning", 5000);
        return;
      }
      this.isLoading = true;
      const caption = this.sended_message && this.sended_message.trim().length > 0 ? this.sended_message : null;
      const formData = new FormData();
      formData.append("file", file);
      if (caption) formData.append("caption", caption);

      this.axios
        .post(`/api/v1/whatsapp_chat/clients/${this.client.id}/files`, formData, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then((response) => {
          this.scrollToBottom();
          this.messages.push({
            "type": 'outgoing',
            "typeMessage": "documentMessage",
            "downloadUrl": response.data.urlFile,
            "textMessage": caption,
            "fileName": file.name,
            "timestamp": Math.floor(Date.now() / 1000)
          });
          this.sended_message = "";
          this.sended_file = null;
        })
        .catch((error) => {
          this.notifyChatError(error);
        })
        .finally(() => (this.isLoading = false));
    },
    // FT-195: ожидаемые ответы прокси (сбой провайдера, большой файл) — понятным текстом, не как баг.
    notifyChatError(error) {
      const key = whatsappChatErrorKey(error);
      if (key) {
        this.$notify(this.$t(key), "", "warning", 5000);
      } else {
        this.setError(error, this.$t("errors.error"));
      }
    },
    saveFile(downloadUrl, fileName) {
      saveAs(downloadUrl, fileName);
    },
    scrollToBottom() {
      // <v-card-text ref="chatContainer" style="scroll-margin-bottom: 150px;">
      var container = this.$refs.chatContainer;
      this.$nextTick(function () {
        if (container) {
          container.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
        }
      });
    },
    formatTime(time) {
      return moment.unix(time).toDate();
    },
    replaceToClientCard() {
      this.$router.push({
        path: `/clients/${this.client.id}`,
      });
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        if (
          this.PageData &&
          this.PageData.backCrumb &&
          this.PageData.backCrumb.url
        ) {
          var fpath = this.PageData.backCrumb.url;
          this.$router.push({
            path: fpath,
          });
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      }
    },
  },
};
</script>
<style scoped>
.chat-message {
  display: unset !important;
  white-space: break-spaces;
}

.chat-screen {
  max-height: 320px;
  overflow-y: auto;
}

.flex-none {
  flex: unset;
}

.received-message::after {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  left: 54px;
  right: auto;
  top: 12px;
  bottom: auto;
  border: 12px solid;
  border-color: #4caf50 transparent transparent transparent;
}

.sent-message::after {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: 54px;
  top: 12px;
  bottom: auto;
  border: 12px solid;
  border-color: #2196f3 transparent transparent transparent;
}
</style>
